export default "__VITE_ASSET__DsB2lJ_q__"